import React, { useEffect, useRef } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";
import FeatherIcon from "feather-icons-react";
import { colors } from "app/popleads/components/ui-kit/colors";
import useGetCainNotifications from "app/popleads/hooks/useGetCainNotifications";
import useMarkCainNotificationAsRead from "app/popleads/hooks/useMarkCainNotificationAsRead";

const ToastTitle = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: ${colors.neutral[900]};
    margin-bottom: 2px;
`;

const ToastMessage = styled.div`
    font-size: 13px;
    color: ${colors.neutral[700]};
`;

/*
 * react-toastify's built-in close button is only readable under `theme="light"`;
 * this app's <ToastContainer theme="colored" /> (src/app/App.js) leaves it white-on-white
 * for a plain (non-colored-type) toast like this one, so it renders invisible rather than
 * absent. Rendering our own icon sidesteps that theme/type coupling entirely.
 */
const CloseButton = styled.button`
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 2px;
    margin: -2px -2px 0 8px;
    color: ${colors.neutral[500]};
    display: flex;
    align-items: flex-start;

    &:hover {
        color: ${colors.neutral[800]};
    }
`;

const renderCloseButton = ({ closeToast }) => (
    <CloseButton type="button" onClick={closeToast} aria-label="Close">
        <FeatherIcon icon="x" size={16} />
    </CloseButton>
);

function ExtensionCainNotificationToasts() {
    const { data } = useGetCainNotifications({ isRead: 0, page: 1, rowsPerPage: 20 });
    const { markAsRead } = useMarkCainNotificationAsRead();
    const shownIds = useRef(new Set());

    useEffect(() => {
        if (!data?.notifications) return;

        data.notifications.forEach((notification) => {
            if (shownIds.current.has(notification.id)) return;
            shownIds.current.add(notification.id);

            toast(
                <div>
                    <ToastTitle>{notification.title}</ToastTitle>
                    <ToastMessage>{notification.message}</ToastMessage>
                </div>,
                {
                    containerId: "cainNotifications",
                    toastId: `cain-notification-${notification.id}`,
                    position: "top-center",
                    autoClose: false,
                    closeOnClick: false,
                    draggable: false,
                    closeButton: renderCloseButton,
                    onClose: () => {
                        markAsRead(notification.id).catch(() => {});
                    },
                }
            );
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    return null;
}

export default ExtensionCainNotificationToasts;
